var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.set_language('hu')}}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }